/**
 * Turning a failed Habitat Admin request into something worth showing
 * someone.
 *
 * Habitat Admin's error handler replaces the message on every error it
 * recognises with `internal_server_error.` and lets only `name`
 * through, so the wording for anything a person can actually act on
 * has to live here. Validation failures are the exception: they never
 * become a `KnownError`, so their message arrives intact and is used
 * as-is.
 */
const ERROR_MESSAGES: Record<string, string> = {
    // Staff Console access
    StaffAccessExists: 'That person already has Staff Console access',
    StaffAccountConflict:
        'A Habitat account already exists for that address and it is not a staff one. Use their +staff address instead.',
    StaffCannotChangeOwnRole: 'You cannot change your own role',
    StaffCannotRemoveSelf: 'You cannot remove your own access',
    StaffAccessNotFound:
        'That person was not found — someone may have removed them already',
    StaffForbidden: 'You do not have permission to do that',

    // Organisations
    OrgNameExists: 'An organisation with that name already exists',
    OrgCreateFailed: 'The organisation could not be created',
    OrgNotFound: 'That organisation no longer exists',
    OrgRequiresAtspUser:
        'This organisation has a user limit, which means it is an ATSP org — the role has to be ATSP user',

    // Accounts
    AccountAlreadyExists:
        'A Habitat account already exists for that email address',
    AccountNotFound: 'No Habitat account was found for that person',

    // Transfers
    SameOrganizationError:
        'The new organisation is the same as the current one',
    UserNotFoundError: 'That user is not in any organisation',
    OrganizationMismatchError:
        'That user has already been moved — reload the page and try again',
    OrganizationNotFoundError:
        'The organisation to move them to does not exist',
    NoUsersModifiedError: 'Nothing was changed, so the transfer was undone',
    NoOrganizationUsersModifiedError:
        'Nothing was changed, so the transfer was undone',
}

export function describeError(
    res: { name?: string; message?: string },
    fallback: string
): string {
    if (res.name && ERROR_MESSAGES[res.name]) {
        return ERROR_MESSAGES[res.name]
    }

    if (res.message && res.message !== 'internal_server_error.') {
        return res.message
    }

    return fallback
}
